import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import config from 'devextreme/core/config'; 
import { licenseKey } from './devextreme-license'; 

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

window.addEventListener("unhandledrejection", (event) => {
  console.log(event.reason);
  event.preventDefault();
});

config({ licenseKey });   

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
